// src/components/lessons/renderers/StepByStepRenderer.jsx
import React from 'react';
import { CheckCircle } from 'lucide-react';

const StepByStepRenderer = ({ block, isMobile }) => {
  const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FEF9C3',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };

  return (
    <div style={{
      background: '#FFFFFF',
      border: '2px solid #3A86FF',
      borderRadius: '0.75rem',
      padding: isMobile ? '1rem' : '1.5rem',
      marginBottom: '1.5rem',
      boxShadow: '0 2px 8px rgba(58, 134, 255, 0.15)',
      position: 'relative'
    }}>
      {/* Title */}
      {block.title && (
        <h4 style={{
          fontSize: isMobile ? '1rem' : '1.1rem',
          fontWeight: '700',
          color: '#1E3A8A',
          marginBottom: '1rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem'
        }}>
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: '#3A86FF',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <CheckCircle size={16} />
          </div>
          {block.title}
        </h4>
      )}

      {/* Instruction */}
      {block.instruction && (
        <div style={{
          background: '#EFF6FF',
          padding: '0.75rem 1rem',
          borderRadius: '0.5rem',
          marginBottom: '1rem',
          borderLeft: '4px solid #3A86FF'
        }}>
          <p style={{
            fontSize: isMobile ? '0.9rem' : '0.95rem',
            color: '#1E40AF',
            margin: 0,
            lineHeight: '1.6'
          }}>
            {processText(block.instruction)}
          </p>
        </div>
      )}

      {/* Redemittel */}
{block.redemittel && (
  <div style={{
    background: '#F9FAFB',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    marginBottom: block.example ? '1rem' : 0,
    border: '1px solid #E5E7EB'
  }}>
    <p style={{
      fontSize: isMobile ? '0.85rem' : '0.9rem',
      color: '#6B7280',
      margin: 0,
      marginBottom: '0.5rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }}>
      Redemittel:
    </p>

    {typeof block.redemittel === 'string' ? (
      <p style={{
        fontSize: isMobile ? '0.9rem' : '0.95rem',
        color: '#374151',
        margin: 0,
        lineHeight: '1.5'
      }}>
        {processText(block.redemittel)}
      </p>
    ) : Array.isArray(block.redemittel) ? (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {block.redemittel.map((item, index) => (
          <p key={index} style={{
            fontSize: isMobile ? '0.9rem' : '0.95rem',
            color: '#374151',
            margin: 0,
            lineHeight: '1.5'
          }}>
            {processText(item)}
          </p>
        ))}
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {Object.entries(block.redemittel).map(([key, value]) => (
          <div key={key} style={{
            display: 'flex',
            gap: '0.5rem',
            fontSize: isMobile ? '0.85rem' : '0.9rem'
          }}>
            <span style={{
              fontWeight: '700',
              color: '#1E40AF',
              minWidth: '80px',
              textTransform: 'capitalize'
            }}>
              {key}:
            </span>
            <span style={{ color: '#374151', flex: 1 }}>
              {processText(value)}
            </span>
          </div>
        ))}
      </div>
    )}
  </div>
)}

      {/* Example */}
      {block.example && (
        <div style={{
          background: '#F0FDF4',
          padding: '0.75rem 1rem',
          borderRadius: '0.5rem',
          border: '1px solid #BBF7D0'
        }}>
          <p style={{
            fontSize: isMobile ? '0.85rem' : '0.9rem',
            color: '#15803D',
            margin: 0,
            marginBottom: '0.5rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Example:
          </p>

          {typeof block.example === 'string' ? (
            <p style={{
              fontSize: isMobile ? '0.9rem' : '0.95rem',
              color: '#166534',
              margin: 0,
              lineHeight: '1.5'
            }}>
              {processText(block.example)}
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
              {Object.entries(block.example).map(([key, value]) => (
                <div key={key} style={{
                  display: 'flex',
                  gap: '0.5rem',
                  fontSize: isMobile ? '0.85rem' : '0.9rem'
                }}>
                  <span style={{
                    fontWeight: '700',
                    color: '#15803D',
                    minWidth: '80px'
                  }}>
                    {key}:
                  </span>
                  <span style={{ color: '#166534' }}>
                    {value}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Decorative corner */}
      <div style={{
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: '12px',
        height: '12px',
        borderTop: '2px solid #3A86FF',
        borderRight: '2px solid #3A86FF',
        opacity: 0.3
      }} />
    </div>
  );
};

export default StepByStepRenderer;